import { isDocRef, TypeGuard } from '@principle-theorem/shared';
import type { IOvieHealthSettingsRequest } from './settings-request';

export enum OvieHealthSettingsSection {
  Practice = 'practice',
  Greeting = 'greeting',
  Messages = 'messages',
  BusinessHours = 'business-hours',
  CallHandling = 'call-handling',
  Routing = 'routing',
  Communications = 'communications',
  BookingCatalog = 'booking/catalog',
  BookingPolicies = 'booking/policies',
  BookingWorkflows = 'booking/workflows',
}

export function isOvieHealthSettingsSection(
  data: unknown
): data is OvieHealthSettingsSection {
  return TypeGuard.enumValue(OvieHealthSettingsSection)(data);
}

export enum OvieHealthSettingsAction {
  GetSettings = 'getSettings',
  GetSection = 'getSection',
  PatchSection = 'patchSection',
  GetAgentNumber = 'getAgentNumber',
}

export const isOvieHealthSettingsRequest =
  TypeGuard.interface<IOvieHealthSettingsRequest>({
    action: TypeGuard.enumValue(OvieHealthSettingsAction),
    practiceRef: isDocRef,
    section: TypeGuard.nilOr(isOvieHealthSettingsSection),
    body: TypeGuard.nilOr(TypeGuard.interface<Record<string, unknown>>({})),
  });
